import { StateRoute } from '../../../../types/interface/fsm.interface'
import { PageInvoicesList } from '../../../../pages/mypages'
import { FSMCommonTransitions } from '../../constants'

const { INVOICES } = FSMCommonTransitions

const routesInvoices: Array<StateRoute> = [
  {
    is: INVOICES,
    page: PageInvoicesList,
  },
]

export default routesInvoices
